/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpMethod } from '../enums/http-method';

export interface ApiRequestOptions {
	method: HttpMethod;
	path: string;
	customUrl?: string;
	data?: any;
	headers?: HttpHeaders;
	params?: HttpParams;
	noLoading?: boolean;
	isShimmer?: boolean;
	shouldCancelPrevious?: boolean;
}
